import React, { useState } from "react";
import Layout from "../common/Layout";
import DynamicTitle from "../common/DynamicTitle";
import ProtectedComponents from "../local-routes/ProtectedComponents";
import MyButton from "../../landingPage/MyButton";
import FormModal from "../form/FormModal";
import { useOrganisationUsers } from "../../../services/organisation/query";
import TableContainer from "../common/TableContainer";
import { Link, useLocation, useParams } from "react-router-dom";
import ActionDropdown from "../common/ActionDropdown";
import Pagination from "../atoms/Pagination";
import { useHistory } from "react-router-dom";
import { removeEmptyObj } from "../../../utils/helperFunctions";
import { StyledDashboardPage } from "../styles/styleDashboard";
import AddJobRole from "../form/AddJobRole";
import SendJobRecommendation from "../form/SendJobRecommendation";

const AdminDevRecommendation = ({ pageType }) => {
  const history = useHistory();
  const location = useLocation();
  const { id, name } = useParams();

  const queryParams = new URLSearchParams(window.location.search);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeModal, setActiveModal] = useState("");
  const initialValues = {
    page: Number(queryParams.get("page")) || 1,
  };
  const [filterOptions, setFilterOptions] = useState(initialValues);
  const [paramsValues, setParamsValues] = useState(
    removeEmptyObj(initialValues, "size") || {}
  );

  const {
    data: organisationUsers,
    refetch: refetchUsers,
    isLoading,
  } = useOrganisationUsers(id, filterOptions.page);

  // const onMutateSuccess = () => {
  //   refetchUsers();
  // };

  // const { mutate: activateUser } = useActivateUser(onMutateSuccess, id);

  const handleModal = (id) => {
    setIsModalOpen(!isModalOpen);
  };

  const increment = () => {
    setParamsValues({ ...paramsValues, page: paramsValues.page + 1 });
    setFilterOptions({ ...filterOptions, page: filterOptions.page + 1 });

    const params = new URLSearchParams({
      ...paramsValues,
      page: paramsValues.page + 1,
    });
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  const decrement = () => {
    setParamsValues({ ...paramsValues, page: paramsValues.page - 1 });
    setFilterOptions({ ...filterOptions, page: filterOptions.page - 1 });

    const params = new URLSearchParams({
      ...paramsValues,
      page: paramsValues.page - 1,
    });
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  const newPage = (n) => {
    setParamsValues({ ...paramsValues, page: n });
    setFilterOptions({ ...filterOptions, page: n });

    const params = new URLSearchParams({ ...paramsValues, page: n });
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  return (
    <Layout navType="admin" pageLoading={isLoading}>
      <DynamicTitle title="Job Roles | Fellowship Product" />
      <StyledDashboardPage isModalOpen={isModalOpen}>
        <Link to="#" onClick={() => history.goBack()} className="goBack">
          <img
            className="back-arrow-img"
            src="/images/back-arrow.svg"
            alt="back arrow"
          />
          <span className="go-back-text ml-2">Go Back</span>
        </Link>
        <div className="page-header">
          <h4>{name} - Job Roles</h4>
          <ProtectedComponents permission={["manageOrganisationUser"]}>
            <div className="d-flex">
              <MyButton
                onClick={() => {
                  handleModal();
                  setActiveModal("add-jobrole");
                }}
                className="btn-comp"
              >
                Create Job Role
              </MyButton>
            </div>
          </ProtectedComponents>
        </div>
        <TableContainer>
          <table style={{ width: "100%" }}>
            <thead style={{ width: "100%" }}>
              <tr>
                <th>Job Title</th>
                <th>Status</th>
                <th>Positions</th>
                <th>Date Created</th>
                <th>Deadline</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ width: "100%" }}>
              {organisationUsers?.data?.content.map((item, index) => (
                <tr className="" key={item.id + index + item.name}>
                  <td>Team Lead, Frontend Developer</td>
                  <td>Open</td>
                  <td>2</td>
                  <td>11/01/2024</td>
                  <td>02/03/2024</td>
                  <td>
                    <ActionDropdown>
                      <ProtectedComponents
                        permission={["manageOrganisationUser"]}
                      >
                        <p
                          onClick={() => {
                            handleModal(item.id);
                            setActiveModal("send-recommendation");
                          }}
                        >
                          Send Recommendations
                        </p>
                        <p>View Recommendations History</p>
                      </ProtectedComponents>
                    </ActionDropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </TableContainer>
        {organisationUsers && (
          <div className="page-parent">
            <Pagination
              currentPage={organisationUsers?.data.number + 1}
              totalClients={organisationUsers?.data.numberOfElements}
              metaData={organisationUsers?.data}
              page={organisationUsers?.data.number + 1}
              newPage={newPage}
              increment={increment}
              decrement={decrement}
              className="pagination"
            />
          </div>
        )}
      </StyledDashboardPage>
      {isModalOpen && (
        <div className="form-modal">
          <FormModal handleModal={handleModal}>
            {activeModal === "add-jobrole" && (
              <AddJobRole onClick={handleModal} reload={refetchUsers} />
            )}
            {activeModal === "send-recommendation" && (
              <SendJobRecommendation handleModal={handleModal} refetch={refetchUsers} />
            )}
          </FormModal>
        </div>
      )}
    </Layout>
  );
};

export default AdminDevRecommendation;
